import React, { useState } from 'react';

import {
  Card,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/AccountCircle';

import CardTitle from '../../../common/card/CardTitle';
import { User } from '../../../user/User.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { BaseHazardCardProps } from '../Hazard.interface';
import HazardAssignPeopleDialog from '../dialogs/HazardAssignPeopleDialog';

const HazardPeopleCard: React.FC<BaseHazardCardProps> = props => {
  const { hazard, hazardVersion, onChange } = props;
  const [assignedUser, setAssignedUser] = useState<User | undefined>();
  const [role, setRole] = useState<'Hazard Owner' | 'Tech Lead' | undefined>();
  const disabled = !!hazardVersion;
  const data = hazardVersion || hazard;
  const { hazardOwner, techLead } = data;

  const assignHazardOwner = (user: User | undefined) => {
    setAssignedUser(user);
    setRole('Hazard Owner');
  };

  const assignTechLead = (user: User | undefined) => {
    setAssignedUser(user);
    setRole('Tech Lead');
  };

  const { isFieldDisabled } = useTaskEntityFields(hazard.task);

  return (
    <Card>
      <CardTitle>
        <PeopleIcon />
        People
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Role</TableCell>
              <TableCell>Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              hover={!disabled && !isFieldDisabled('hazardOwner')}
              onClick={() => {
                if (!disabled && !isFieldDisabled('hazardOwner')) {
                  assignHazardOwner(hazardOwner);
                }
              }}
            >
              <TableCell>Hazard Owner</TableCell>
              <TableCell>
                {hazardOwner ? (
                  `${hazardOwner?.firstName} ${hazardOwner?.lastName}`
                ) : disabled || isFieldDisabled('hazardOwner') ? (
                  'not assigned'
                ) : (
                  <Link
                    component='button'
                    variant='body2'
                    disabled={disabled || isFieldDisabled('hazardOwner')}
                    onClick={() => assignHazardOwner(undefined)}
                  >
                    Assign
                  </Link>
                )}
              </TableCell>
            </TableRow>
            <TableRow
              hover={!disabled && !isFieldDisabled('techLead')}
              onClick={() => {
                if (!disabled && !isFieldDisabled('techLead')) {
                  assignTechLead(techLead);
                }
              }}
            >
              <TableCell>Tech Lead</TableCell>
              <TableCell>
                {techLead ? (
                  `${techLead?.firstName} ${techLead?.lastName}`
                ) : disabled || isFieldDisabled('techLead') ? (
                  'not assigned'
                ) : (
                  <Link
                    component='button'
                    variant='body2'
                    disabled={disabled || isFieldDisabled('techLead')}
                    onClick={() => assignTechLead(undefined)}
                  >
                    Assign
                  </Link>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {role && !disabled && (
        <HazardAssignPeopleDialog
          open={Boolean(role)}
          hazardId={hazard.id}
          assignedUser={assignedUser}
          role={role}
          onCancel={() => setRole(undefined)}
          onAssigned={updated => {
            setRole(undefined);
            onChange?.(updated);
          }}
        />
      )}
    </Card>
  );
};

export default HazardPeopleCard;
